module.exports = __webpack_public_path__ + "img/girl.3416d718.jpg";